// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"367":"111b75fd","406":"12be6775","909":"111b75fd"}[chunkId] + ".chunk.css";
};